/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: LoadingIndicator.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  01.11.23 11:52 am.
 * Last modified: 01.11.23 11:52 am.
 *
 * More information at: https://egt-digital.com/
 */

import React, { useEffect, useRef, useState } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import store from '../../eventStore';

const LoadingIndicator = () => {
    const [{ openType }] = useSettings();
    const [visible, setVisible] = useState<boolean>(!store.SETTINGS_REQUEST_DONE.value);

    const animationWrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const subscription = store.SETTINGS_REQUEST_DONE.subscribe(done => {
            if (done) {
                animationWrapperRef?.current?.classList.add('loading_indicator_fade_out');
                setTimeout(() => setVisible(!done), 750);
            }
        });

        return () => subscription.unsubscribe();
    }, []);

    return (
        <>
            {visible && (
                <div
                    className={`egtd-lobby-loading-indicator egtd-lobby-loading-indicator-${
                        openType === 'fullscreen' ? 'fullscreen' : 'ingame'
                    }`}
                    style={{
                        ...(visible ? {} : { display: 'none' }),
                    }}
                    ref={animationWrapperRef}
                >
                    {/* START - Loading css animation object for lazy loaded images */}
                    <div className="egt_lobby_loading_animation_wrapper">
                        <div className="egt_lobby_logo_loading_activity">
                            <div className="egt_lobby_circle_logo">
                                {/* Place the egt digital logo here optionally */}
                            </div>
                            <div className="egt_lobby_logo_svg_loader">
                                <svg
                                    className="egt_lobby_logo_svg_container"
                                    height="72"
                                    width="72"
                                    viewBox="0 0 100 100"
                                >
                                    <circle
                                        className="egt_lobby_logo_loader_svg egt_lobby_loading_logo_bg"
                                        cx="50"
                                        cy="50"
                                        r="45"
                                    ></circle>
                                    <circle
                                        className="egt_lobby_logo_loader_svg egt_lobby_loading_logo_animate"
                                        cx="50"
                                        cy="50"
                                        r="45"
                                    ></circle>
                                </svg>
                            </div>
                        </div>
                    </div>
                    {/* END - Loading css animation object for lazy loaded images */}
                </div>
            )}
        </>
    );
};

export default LoadingIndicator;
